var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.712,
    height: 54.446,
    viewBox: "0 0 55.712 54.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 27.223,
    cy: 27.856,
    rx: 27.223,
    ry: 27.856,
    transform: "translate(0 54.446) rotate(-90)",
    fill: "#f2b229"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M27.191,7.437a3.355,3.355,0,0,0-2.36-2.376C22.748,4.5,14.4,4.5,14.4,4.5s-8.349,0-10.431.562a3.355,3.355,0,0,0-2.36,2.376,35.193,35.193,0,0,0-.558,6.468,35.193,35.193,0,0,0,.558,6.468,3.3,3.3,0,0,0,2.36,2.338c2.082.562,10.431.562,10.431.562s8.349,0,10.431-.562a3.3,3.3,0,0,0,2.36-2.338,35.193,35.193,0,0,0,.558-6.468,35.193,35.193,0,0,0-.558-6.468ZM11.669,17.875V9.936l6.978,3.97-6.978,3.97Z",
    transform: "translate(13.457 13.337)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoYoutube);
export default __webpack_public_path__ + "static/media/ico_youtube.d752090004ca87928f987717a16e0c61.svg";
export { ForwardRef as ReactComponent };